import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_option_field = _resolveComponent("option-field")

  return (_openBlock(), _createBlock(_component_option_field, {
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model) = $event)),
    "display-name": $props.option.text,
    options: $options.getOptions($props.option),
    class: _normalizeClass(['gfu-field-select--primary', $props.fieldClass]),
    "show-placeholder": true,
    name: "model",
    "show-label": $props.showLabel,
    "label-class": $props.labelClass,
    inline: $props.inline,
    small: $props.small,
    "no-option-capitalize": true,
    disabled: $props.disabled,
    onChange: $options.onChange,
    "data-qa": 'product-option-field:' + $props.option.text
  }, null, 8 /* PROPS */, ["modelValue", "display-name", "options", "class", "show-label", "label-class", "inline", "small", "disabled", "onChange", "data-qa"]))
}